import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-page__tab-content profile-page__my-content" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]


const __default__ = {
  name: 'ContentTab',
}
import DownloadableFilesTable from './content/DownloadableFilesTable.vue'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", {
        class: "profile-page__section-header",
        textContent: _toDisplayString('Purchased Content')
      }, null, 8, _hoisted_2),
      _createElementVNode("p", {
        class: "profile-page__my-content__subtitle",
        textContent: _toDisplayString(`We've got all your downloaded content here in one easy-to-access area.`)
      }, null, 8, _hoisted_3)
    ]),
    _createVNode(DownloadableFilesTable)
  ]))
}
}

})